import { Typography } from 'antd'
import { I18nContext } from 'contexts/I18n/I18nProvider'
import { useContext } from 'react'
import SortIcon from '../components/SortIcon'
import { TableProps } from '../types'

type WithCheckBoxProps<T, K> = TableProps<T, K> & {
  configMap: Array<string>
}

export default function Simple<T, K>({ header, items, configMap, onSortCallback, sort }: WithCheckBoxProps<T, K>) {
  const t = useContext(I18nContext)

  return (
    <div className="simple-table-with-checkbox">
      <div className="simple-table-header">
        <div className="columns">
          {header.map((config) => <div className='column' key={config.key}>
            {t(config.label)}
            {onSortCallback ? SortIcon({ field: config, sort, onSortCallback }) : ''}
          </div>)}
        </div>
      </div>
      <div>
        <div className="simple-table-body">
          {items.map((item: any, rowIndex) => <div
            className={`columns ${rowIndex % 2 !== 0 && 'stripped'} simple-table-with-checkbox-row`}
            key={rowIndex}>
            {configMap.map((key, index) => <div className='column' key={index}>
              <Typography.Text>{item[key]}</Typography.Text>
            </div>)}
          </div>)}
        </div>
      </div>
    </div>
  )
}
